import { StyledDefactoHeading, StyledDefaqtoLogo, StyledDefaqtoWrapper } from './styles';

export const DefaqtoBanner = () => {
    const id = 'defacto-banner-title';
    return (
        <StyledDefaqtoWrapper role="banner" aria-labelledby={id}>
            <StyledDefaqtoLogo src="/assets/defaqto.png" alt="Defaqto Logo" />
            <StyledDefactoHeading level={4} id={id}>
                A 5-star pension, built on nearly 200 years of experience
            </StyledDefactoHeading>
        </StyledDefaqtoWrapper>
    );
};
